import { is } from "date-fns/locale";
import { invokeApi } from "../invokeApi";

export const _Client_Center_List = async (search) => {
  const requestObj = {
    path: `/api/customer/list_customer_for_chat?search=${search || ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Exiting_Messages = async (id) => {
  const requestObj = {
    path: `/api/chat/exist_chat/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _List_Chat_Messages = async (id) => {
  const requestObj = {
    path: `/api/chat/list_message/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _List_Chat = async (is_chat, search) => {
  const requestObj = {
    path: `/api/chat/list_chat?is_end=${is_chat}&search=${search || ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Make_Count_Zero = async (chat_id) => {
  const requestObj = {
    path: `/api/chat/set_zero_unread_message_count/${chat_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
